"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventHandlers = void 0;
var react_1 = require("react");
var crop_bit_matrix_1 = require("../../../functions/bit-matrix/crop-bit-matrix");
var exact_bounding_rect_1 = require("../../../functions/bit-matrix/exact-bounding-rect");
var paint_object_1 = require("../../../types/record/paint-object");
var useEventHandlers = function (selectedLabel, bitMatrix, croppedRectPixelSize, setPlotMode, onClose, idMaker) {
    var onButtonClick = (0, react_1.useCallback)(function (id) {
        switch (id) {
            case '+':
                setPlotMode('+');
                break;
            case '-':
                setPlotMode('-');
                break;
            default:
                break;
        }
    }, [setPlotMode]);
    var onSaveClick = (0, react_1.useCallback)(function () {
        var exactBox = (0, exact_bounding_rect_1.exactBoundingRect)(bitMatrix);
        var croppedBitMatrix = (0, crop_bit_matrix_1.cropBitMatrix)(bitMatrix, exactBox);
        var result = (0, paint_object_1.IPaintObject)({
            id: idMaker(),
            label: selectedLabel,
            pixelTop: croppedRectPixelSize.top + exactBox.top,
            pixelLeft: croppedRectPixelSize.left + exactBox.left,
            bitMatrix: croppedBitMatrix
        });
        onClose(result);
        setPlotMode('+'); // reset
    }, [
        onClose,
        setPlotMode,
        bitMatrix,
        croppedRectPixelSize,
        selectedLabel,
        idMaker
    ]);
    var onDiscardClick = (0, react_1.useCallback)(function () {
        onClose(undefined);
        setPlotMode('+'); // reset
    }, [onClose, setPlotMode]);
    return {
        onButtonClick: onButtonClick,
        onSaveClick: onSaveClick,
        onDiscardClick: onDiscardClick
    };
};
exports.useEventHandlers = useEventHandlers;
